import AddAssessmentInsuranceAuthorization from './assessmentType';
import AddTreatmentInsuranceAuthorization from './treatmentType';

import './index.scss';

const AddInsuranceAuthorization = () => (
	<div className="addInsuranceAuthorization">
		<AddAssessmentInsuranceAuthorization />
		<AddTreatmentInsuranceAuthorization />
	</div>
);

export default AddInsuranceAuthorization;
